
export enum TypeActivite {
  éditeur = "éditeur", 
  autoédition = "auto-édition", 
  commercialisationDuLivre = "commercialisation du livre",
  Diffusion= "diffusion",
  Distribution ="distribution",
  DiffusionDistribution= "diffusion / distribution",
  libraire ="libraire" ,
  grossiste ="grossiste", 
  comptoirDeVente= "comptoir de vente" ,
  importateur ="importateur",
  inconnu = "inconnu"
}

  //"1" (éditeur) ; 
  //"2" (auto-édition) ; 
  //"3" (commercialisation du livre) ; 
  //"3.01" (diffusion) ; 
  //"3.02" (distribution) ; 
  //"3.03" ( diffusion / distribution) ; 
  //"3.04" (libraire) ; 
  //"3.05" (grossiste) ; 
  //"3.06" (comptoir de vente) ; 
  //"3.07" (importateur)

export function idTypeActiviteToTypeActivite(id: string): TypeActivite {
  switch (id) {
    case "1":
      return TypeActivite.éditeur;
    case "2":
      return TypeActivite.autoédition;
    case "3":
      return TypeActivite.commercialisationDuLivre;
    case "3.01":
      return TypeActivite.Diffusion;
    case "3.02":
      return TypeActivite.Distribution;
    case "3.03":
      return TypeActivite.DiffusionDistribution;
    case "3.04":
      return TypeActivite.libraire;
    case "3.05":
      return TypeActivite.grossiste;
    case "3.06":
      return TypeActivite.comptoirDeVente;
    case "3.07":
        return TypeActivite.importateur;
    default:
      return TypeActivite.inconnu;
  }
}
